<template>
    <div class="columns is-mobile is-centered has-background-primary p-2"  v-if="props.vista=='completa'">
        <h1 class="title is-4 has-text-white"><i class="fas fa-arrow-right-from-bracket"></i> &nbsp; CONTABILE</h1>
    </div>

    <div class="box" @submit.prevent="" v-if="formAttivo">

        <div class="columns">
            <div class="column">
                <div class="field buttons">
                    <button class="button is-light" v-if="props.vista=='completa'" @click="bAnnulla" :disabled="!contabileDaAggiornare">Annulla</button>
                    <button class="button is-light" v-if="props.vista=='ridotta'" @click="bChiudi">Chiudi</button>
                    <button class="button is-primary" @click="bSalva" :disabled="!contabileDaAggiornare">Salva</button>
                </div>                
            </div>
            <div class="column" v-if="props.vista=='completa'">
                <p>
                    <a @click="gestisciSelezioneElemento({tipo: 'cliente', idCliente: props.idCliente})" title="Vai al cliente">
                        <i class="fas fa-user"></i> &nbsp; {{ generaStringaCliente(props.idCliente) }}
                    </a>
                </p>
            </div>
            <div class="column" v-if="props.vista=='completa'">
                <p>
                    <a @click="gestisciSelezioneElemento({tipo: 'lavoro', idCliente: props.idCliente, idLavoro: props.idLavoro})" title="Vai al lavoro">
                        <i class="fas fa-arrow-right-from-bracket"></i> &nbsp; {{ dbClienti[props.idCliente]?.lavori?.[props.idLavoro]?.oggetto || "Lavoro" }}
                    </a>
                </p>
            </div>
            <div class="column">
                <div class="field buttons is-right">
                    <button class="button is-danger" @click="bElimina" v-if="idContabileSelezionata!=-1">Elimina</button>
                </div>
            </div>
        </div>

        <div class="columns">

            <div class="column is-2">
                <CampoData  @valoreCambiato="contabileModifica"
                    :valore=contabileSelezionata.data
                    identificativo="data"
                    etichetta="Data"/>
            </div>
            <div class="column is-3">
                <div class="field">
                    <label class="label">Causale</label>
                    <div class="control">
                        <input class="input" type="text" v-model="contabileSelezionata.causale"  @change="contabileModifica(contabileSelezionata.causale, 'causale')">
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <CampoNumero @valoreCambiato="contabileModifica"
                    :valore=contabileSelezionata.preventivo
                    identificativo="preventivo"
                    etichetta="Preventivo"
                    :decimali = 2
                    tipo="Decimale"/>
            </div>
            <div class="column is-2">
                <CampoNumero @valoreCambiato="contabileModifica"
                    :valore=contabileSelezionata.consuntivo
                    identificativo="consuntivo"
                    etichetta="Consuntivo"
                    :decimali = 2
                    tipo="Decimale"/>
            </div>
            <div class="column is-2">
                <CampoNumero @valoreCambiato="contabileModifica"
                    :valore=contabileSelezionata.fattura
                    identificativo="fattura"
                    etichetta="Fattura"
                    :decimali = 2
                    tipo="Decimale"/>
            </div>
            <div class="column is-1">
                <CampoNumero @valoreCambiato="contabileModifica"
                    :valore=contabileSelezionata.ordine
                    identificativo="ordine"
                    etichetta="Ordine"
                    tipo="Intero"/>
            </div>
        </div>
    </div>

    <MessaggioModale @selezionato="bComandoModale"
        :confMessaggioModale=messaggioModale
        v-if="messaggioModale"/>

</template>

<script setup>
    import CampoData from "./CampoData.vue";
    import CampoNumero from "./CampoNumero.vue";
    import MessaggioModale from "./MessaggioModale.vue";
    // FIX: Importati nextTick, watch
    import { defineProps, defineEmits, ref, nextTick, watch } from "vue";
    import { dbClienti, salvaContabileInFirestore, eliminaContabileInFirestore, leggiInfoDBRaw, aggiungiInfoDB } from "./../code/gestioneDB";
    // FIX: Importato generaStringaCliente
    import { generaIdContabile, clonaOggetto, generaStringaCliente } from "./../code/utilita";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        idContabile: {
            type: Number,
            default: -1
        },
        idLavoro: {
            type: Number,
            required: true
        },
        idCliente: {
            type: Number,
            required: true
        },
        vista: {                    // completa, ridotta
            type: String,
            default: 'completa'
        }
    });
    const emit = defineEmits(['elementoSelezionato', 'modificaElementoInCorso']);

    // VARIABILI DEL COMPONENTE
    // FIX: Trasformato da let a const ref({}) per coerenza e reattività
    const contabileSelezionata = ref({});               
    const contabileDaAggiornare = ref(null);            
    const messaggioModale = ref(null);                  
    const idContabileSelezionata = ref(props.idContabile || -1);
    const formAttivo = ref(true); 

    // FIX: Watcher di sicurezza per cambi asincroni (allineato a FormLead)
    watch(() => props.idContabile, (nuovoId) => {
        idContabileSelezionata.value = nuovoId || -1;
        setupFormContabile();
    });

    // SETUP DEL COMPONENTE
    setupFormContabile();

    // FUNZIONI DEL COMPONENTE
    function setupFormContabile() {
        const id = idContabileSelezionata.value;

        // FIX: Scheletro di Base 
        const scheletroBase = {
            data: null,
            causale: null,
            preventivo: null,
            consuntivo: null,
            fattura: null,
            ordine: null
        };

        if ( id == -1 ) {
            contabileSelezionata.value = { ...scheletroBase };
            aggiungiInfoDB(contabileSelezionata.value, {
                id: -1,
                idCliente: props.idCliente,
                idLavoro: props.idLavoro
            });
        } else {
            // FIX: Estrazione Sicura
            const clienteOriginale = dbClienti.value[props.idCliente];
            const lavoroOriginale = (clienteOriginale && clienteOriginale.lavori) ? clienteOriginale.lavori[props.idLavoro] : null;
            const contabileOriginale = (lavoroOriginale && lavoroOriginale.contabili) ? lavoroOriginale.contabili[id] : null;

            if (contabileOriginale) {
                contabileSelezionata.value = { ...scheletroBase, ...clonaOggetto(contabileOriginale) };
                
                // FIX: Ricostruisce i metadati (DNA) per il clone orfano
                const infoRaw = leggiInfoDBRaw(contabileOriginale) || { id: id, idCliente: props.idCliente, idLavoro: props.idLavoro };
                aggiungiInfoDB(contabileSelezionata.value, infoRaw);
            } else {
                contabileSelezionata.value = { ...scheletroBase };
                aggiungiInfoDB(contabileSelezionata.value, { id: id, idCliente: props.idCliente, idLavoro: props.idLavoro });
            }
        }
        contabileDaAggiornare.value = null;
    }

    function contabileModifica(valore, etichetta) {
        if (contabileDaAggiornare.value == null) {
            contabileDaAggiornare.value = {};
            emit('modificaElementoInCorso', true);
        }
        contabileDaAggiornare.value[etichetta] = valore;
        // FIX: Allinea anche contabileSelezionata per coerenza col v-model
        contabileSelezionata.value[etichetta] = valore;
    }

    function bChiudi() {
        if (contabileDaAggiornare.value != null) {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:null,
                testoDanger:{testo:'Chiudi senza salvare', comando:'chiudi'},
                messaggio:"Proseguendo perderai le modifiche fatte"
            };
        } else {
            emit('elementoSelezionato', {
                tipo: 'contabile',
                idCliente: null,
                idLavoro: null,
                idDico: null
            });
        }
    }

    function bAnnulla() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:null,
            testoDanger:{testo:'Cancella le modifiche', comando:'cancella'},
            messaggio:"Proseguendo perderai le modifiche fatte"
        };
    }

    function bSalva() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:{testo:'Salva', comando:'salva'},
            testoDanger:null,
            messaggio:"Vuoi salvare le modifiche alla contabile?"
        };
    }

    function bElimina() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:null,
            testoDanger:{testo:'Elimina', comando:'elimina'},
            messaggio:"Vuoi eliminare la contabile?"
        };
    }

    async function bComandoModale(comando) {
        // FIX: Sicurezza estrazione ID per operare sul DB
        const tpIdCliente = leggiInfoDBRaw(contabileSelezionata.value)?.idCliente || props.idCliente;
        const tpIdLavoro = leggiInfoDBRaw(contabileSelezionata.value)?.idLavoro || props.idLavoro;

        // FIX: Raggruppati in scope isolati ({ }) per ESLint
        switch (comando) {
            case 'annulla': {
                messaggioModale.value = null;
                break;
            }
            case 'cancella': {
                emit('modificaElementoInCorso', false);
                messaggioModale.value = null;
                setupFormContabile();
                resetForm(); // FIX: Reset reattivo
                break;
            }
            case 'chiudi': {
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'contabile',
                    idCliente: null,
                    idLavoro: null,
                    idContabile: null
                });
                messaggioModale.value = null;
                break;
            }
            case 'salva': {
                if (idContabileSelezionata.value == -1) {
                    idContabileSelezionata.value = generaIdContabile(tpIdCliente, tpIdLavoro);
                }
                aggiungiInfoDB(contabileDaAggiornare.value, {
                    id: idContabileSelezionata.value,
                    idCliente: tpIdCliente,
                    idLavoro: tpIdLavoro
                });
                await salvaContabileInFirestore(contabileDaAggiornare.value);
                setupFormContabile();
                messaggioModale.value = null;
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'contabile',
                    idCliente: tpIdCliente,
                    idLavoro: tpIdLavoro,
                    idContabile: idContabileSelezionata.value
                });
                break;
            }
            case 'elimina': {
                eliminaContabileInFirestore(tpIdCliente, tpIdLavoro, idContabileSelezionata.value);
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'contabili'
                });
                break;
            }
        }
    }

    function gestisciSelezioneElemento(elSelezionato) {
        if (contabileDaAggiornare.value != null) {
            messaggioModale.value = {
                testoLight:{testo:'Ok', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Per proseguire devi salvare o annullare le modifiche."
            };
        } else {
            emit('elementoSelezionato', elSelezionato);
        }
    }

    async function resetForm() {
        formAttivo.value = false;
        await nextTick();
        formAttivo.value = true;
    }

</script>